<template>
  <multi-language-code-field
    :input="input"
    :disabled="disabled"
    :languages="languages"
    :code-types="codeTypes"
    @update="$emit('update', $event)"
  />
</template>

<script>
import MultiLanguageCodeField from './MultiLanguageCodeField';

export default {
  name: 'PageMultiLanguageHtmlCssFormField',

  components: {
    MultiLanguageCodeField,
  },

  props: {
    input: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    languages: {
      type: Array,
      required: true
    },
  },

  data() {
    return {
      codeTypes: [
        { key: 'html', label: 'HTML', editorLanguage: 'html' },
        { key: 'css', label: 'CSS', editorLanguage: 'css' },
      ],
    }
  },
}
</script>
